import { Box, Button, Grid2, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import ArrowCircleLeftOutlinedIcon from "@mui/icons-material/ArrowCircleLeftOutlined";
import MyLocationOutlinedIcon from "@mui/icons-material/MyLocationOutlined";
import { Geolocation } from "@capacitor/geolocation";
import { useSelector } from "react-redux";
import axios from "axios";

const CreateProfile = () => {
  const user = useSelector((state) => state.user.user);
  const [durables, setDurables] = useState([]);
  const [profile, setProfile] = useState({
    firstName: "",
    lastName: "",
    gender: "",
    education: "",
    occupation: "",
    age: "",
    city: "",
    pincode: "",
    location: "",
  });
  const [geoError, setGeoError] = useState();
  const [isFetchingCity, setIsFetchingCity] = useState(false);
  const navigate = useNavigate();

  const handleChange = (e) => {
    setProfile({ ...profile, [e.target.name]: e.target.value });
    if (e.target.name === "pincode" && e.target.value.length === 6) {
      getLocation(e.target.value);
    }
  };

  const handleSelectDurables = (durable) => {
    if (durables.includes(durable)) {
      setDurables(durables.filter((item) => item !== durable));
    } else {
      setDurables([...durables, durable]);
    }
  };

  const handleNext = (e) => {
    e.preventDefault();
    if (
      !profile.firstName ||
      !profile.lastName ||
      !profile.age ||
      !profile.education ||
      !profile.occupation ||
      !profile.gender
    ) {
      alert(`Some fields is missing. Please fill in the required information.`);
      return;
    }

    if (!durables || durables.length === 0) {
      alert(
        "Durables data is missing. Please provide the required information."
      );
      return;
    }
    sessionStorage.setItem("profile", JSON.stringify(profile));
    sessionStorage.setItem("durables", JSON.stringify(durables));
    navigate("/profile/app");
  };

  const getLocation = async (pincode) => {
    try {
      const res = await axios.get(
        `https://api.postalpincode.in/pincode/${pincode}`
      );
      console.log(res.data[0].PostOffice[0]);
      setProfile((prevState) => ({
        ...prevState,
        city: res.data[0].PostOffice[0].Region,
      }));
    } catch (error) {
      console.log(error);
    }
    setGeoError("");
    try {
      setIsFetchingCity(true);
      const position = await Geolocation.getCurrentPosition();

      const lat = position.coords.latitude;
      const lon = position.coords.longitude;

      const nominatimUrl = `https://nominatim.openstreetmap.org/reverse?format=json&lat=${lat}&lon=${lon}&addressdetails=1`;

      const response = await fetch(nominatimUrl);
      const data = await response.json();
      console.log(data);
      if (data && data.address) {
        const city =
          data.address.city || data.address.town || data.address.village;
        const district = data.address.county;

        const location = city
          ? city
          : district
          ? district
          : "City/District not found.";

        setProfile((prevState) => ({
          ...prevState,
          location: location,
        }));
      } else {
        setProfile((prevState) => ({
          ...prevState,
          location: null,
        }));
      }
    } catch (error) {
      console.error("Error fetching location:", error);
      setProfile((prevState) => ({
        ...prevState,
        location: null,
      }));
    } finally {
      setIsFetchingCity(false);
    }
  };

  useEffect(() => {
    if (!user || !JSON.parse(localStorage.getItem("user"))) {
      navigate("/");
    }
  }, []);

  return (
    <Box sx={{display: {xs: 'block', sm: 'none !important'}}}>
      <div className="eclipse1"></div>
      <div className="eclipse2"></div>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          padding: "20px",
          zIndex: 100,
          position: "relative",
        }}
      >
        <Link to={"/register"}>
          <ArrowCircleLeftOutlinedIcon sx={{ color: "#fff" }} />
        </Link>
        <Typography className="heading" sx={{ marginLeft: "10px" }}>
          Create Profile
        </Typography>
      </Box>
      <Box className="main-container">
        <form style={{ display: "flex", flexDirection: "column" }}>
          <input
            type="text"
            name="firstName"
            id="firstName"
            placeholder="First Name"
            onChange={handleChange}
          />
          <input
            type="text"
            name="lastName"
            id="lastName"
            placeholder="Last Name"
            onChange={handleChange}
          />
          <select name="gender" id="gender" onChange={handleChange}>
            <option value="">Gender</option>
            <option value="Male">Male</option>
            <option value="Female">Female</option>
          </select>

          <select name="occupation" id="occuptaion" onChange={handleChange}>
            <option value="">Occupation</option>
            <option value="Services">Services</option>
            <option value="Business">Business</option>
            <option value="Self_Employed">Self Employed Professional</option>
            <option value="Student">Student</option>
            <option value="Retired">Retired</option>
            <option value="Farmer">Farmer</option>
            <option value="Other">Other</option>
          </select>
          <select name="age" id="age" onChange={handleChange}>
            <option value="">Age</option>
            <option value="18-25">18-25</option>
            <option value="26-30">26-30</option>
            <option value="31-35">31-35</option>
            <option value="36-40">36-40</option>
            <option value="41-45">41-45</option>
            <option value="46-50">46-50</option>
            <option value="51-60">51-60</option>
            <option value="60+">More than 60</option>
          </select>
          {/* <select name="city" id="city" onChange={handleChange}>
            <option value="">City</option>
            <option value="Mumbai">Mumbai</option>
            <option value="Pune">Pune</option>
          </select> */}
          <input
            type="text"
            name="pincode"
            id="pincode"
            placeholder="Enter your pincode"
            onChange={handleChange}
          />
          <input
            type="text"
            name="city"
            id="city"
            placeholder="City"
            value={isFetchingCity ? "Loading..." : profile.city}
            readOnly
          />
          {geoError && (
            <p
              style={{
                margin: "0 0 12px 15px",
                fontSize: "12px",
                color: "red",
              }}
            >
              Error: {geoError}
              <br />
              Note: Please make sure to turn on your device location
            </p>
          )}
          <label htmlFor="education" style={{ padding: "0 15px" }}>
            Which of these best describes the highest level of education of the
            chief wage earner or head of your household?
          </label>
          <select name="education" id="education" onChange={handleChange}>
            <option value="">Education</option>
            <option value="Below Secondary/senior/high school">
              Below Secondary/Senior/High School
            </option>
            <option value="Secondary/senior/high school complete">
              Secondary/Senior/High School Complete
            </option>
            <option value="College/university incomplete">
              College/University Incomplete
            </option>
            <option value="College/university complete(graduate)">
              College/University Complete(Graduate)
            </option>
            <option value="Post graduate studies incomplete">
              Post Graduate Studies Incomplete (No Post Graduate Degree)
            </option>
            <option value="Post graduate studies complete">
              Post Graduate Studies Complete (Post Graduate Degree)
            </option>
          </select>
          <Box>
            <Typography sx={{ fontSize: "16px", padding: "0 15px" }}>
              Which of these items do you have in working order in your home?
            </Typography>
            <Grid2 container rowSpacing={2} columnSpacing={2} my={2}>
              <Grid2 size={{ xs: 6 }}>
                <Box
                  className={
                    durables.includes("AC") ? "box-option-select" : "box-option"
                  }
                  sx={{ textTransform: "capitalize" }}
                  onClick={() => handleSelectDurables("AC")}
                >
                  Air conditioning(Built in)
                </Box>
              </Grid2>
              <Grid2 size={{ xs: 6 }}>
                <Box
                  className={
                    durables.includes("Water_filtering")
                      ? "box-option-select"
                      : "box-option"
                  }
                  sx={{ textTransform: "capitalize" }}
                  onClick={() => handleSelectDurables("Water_filtering")}
                >
                  Water filtering device
                </Box>
              </Grid2>
              <Grid2 size={{ xs: 6 }}>
                <Box
                  className={
                    durables.includes("Dining_table")
                      ? "box-option-select"
                      : "box-option"
                  }
                  sx={{ textTransform: "capitalize" }}
                  onClick={() => handleSelectDurables("Dining_table")}
                >
                  Dining table
                </Box>
              </Grid2>
              <Grid2 size={{ xs: 6 }}>
                <Box
                  className={
                    durables.includes("Oven")
                      ? "box-option-select"
                      : "box-option"
                  }
                  sx={{ textTransform: "capitalize" }}
                  onClick={() => handleSelectDurables("Oven")}
                >
                  Microwave oven
                </Box>
              </Grid2>
              <Grid2 size={{ xs: 6 }}>
                <Box
                  className={
                    durables.includes("Refrigerator")
                      ? "box-option-select"
                      : "box-option"
                  }
                  sx={{ textTransform: "capitalize" }}
                  onClick={() => handleSelectDurables("Refrigerator")}
                >
                  Refrigerator (NOT separate freezer section)
                </Box>
              </Grid2>
              <Grid2 size={{ xs: 6 }}>
                <Box
                  className={
                    durables.includes("Fridge")
                      ? "box-option-select"
                      : "box-option"
                  }
                  sx={{ textTransform: "capitalize" }}
                  onClick={() => handleSelectDurables("Fridge")}
                >
                  Fridge freezer (seperate freezer section)
                </Box>
              </Grid2>

              <Grid2 size={{ xs: 6 }}>
                <Box
                  className={
                    durables.includes("Washing_machine")
                      ? "box-option-select"
                      : "box-option"
                  }
                  sx={{ textTransform: "capitalize" }}
                  onClick={() => handleSelectDurables("Washing_machine")}
                >
                  Washing machine
                </Box>
              </Grid2>
              <Grid2 size={{ xs: 6 }}>
                <Box
                  className={
                    durables.includes("Kitchen_sink")
                      ? "box-option-select"
                      : "box-option"
                  }
                  sx={{ textTransform: "capitalize" }}
                  onClick={() => handleSelectDurables("Kitchen_sink")}
                >
                  Kitchen sink
                </Box>
              </Grid2>

              <Grid2 size={{ xs: 6 }}>
                <Box
                  className={
                    durables.includes("Telephone")
                      ? "box-option-select"
                      : "box-option"
                  }
                  sx={{ textTransform: "capitalize" }}
                  onClick={() => handleSelectDurables("Telephone")}
                >
                  Telephone (landline)
                </Box>
              </Grid2>
              <Grid2 size={{ xs: 6 }}>
                <Box
                  className={
                    durables.includes("PC") ? "box-option-select" : "box-option"
                  }
                  sx={{ textTransform: "capitalize" }}
                  onClick={() => handleSelectDurables("PC")}
                >
                  PC/desktop computers
                </Box>
              </Grid2>

              <Grid2 size={{ xs: 6 }}>
                <Box
                  className={
                    durables.includes("Motor_cars")
                      ? "box-option-select"
                      : "box-option"
                  }
                  sx={{ textTransform: "capitalize" }}
                  onClick={() => handleSelectDurables("Motor_cars")}
                >
                  Motor cars
                </Box>
              </Grid2>

              <Grid2 size={{ xs: 6 }}>
                <Box
                  className={
                    durables.includes("Laptop")
                      ? "box-option-select"
                      : "box-option"
                  }
                  sx={{ textTransform: "capitalize" }}
                  onClick={() => handleSelectDurables("Laptop")}
                >
                  Laptop computers
                </Box>
              </Grid2>
              <Grid2 size={{ xs: 6 }}>
                <Box
                  className={
                    durables.includes("Camera")
                      ? "box-option-select"
                      : "box-option"
                  }
                  sx={{ textTransform: "capitalize" }}
                  onClick={() => handleSelectDurables("Camera")}
                >
                  Still cameras (digital)
                </Box>
              </Grid2>
              <Grid2 size={{ xs: 6 }}>
                <Box
                  className={
                    durables.includes("Video_camera")
                      ? "box-option-select"
                      : "box-option"
                  }
                  sx={{ textTransform: "capitalize" }}
                  onClick={() => handleSelectDurables("Video_camera")}
                >
                  Video cameras (digital)
                </Box>
              </Grid2>
              <Grid2 size={{ xs: 6 }}>
                <Box
                  className={
                    durables.includes("CRT_TV")
                      ? "box-option-select"
                      : "box-option"
                  }
                  onClick={() => handleSelectDurables("CRT_TV")}
                >
                  Colour TVs CRT (cathode ray tube)
                </Box>
              </Grid2>
              <Grid2 size={{ xs: 6 }}>
                <Box
                  className={
                    durables.includes("TV") ? "box-option-select" : "box-option"
                  }
                  sx={{ textTransform: "capitalize" }}
                  onClick={() => handleSelectDurables("TV")}
                >
                  Colour TVs LCD / Plasma TVs
                </Box>
              </Grid2>
              <Grid2 size={{ xs: 12 }}>
                <Box
                  className={
                    durables.includes("Home_cinema")
                      ? "box-option-select"
                      : "box-option"
                  }
                  sx={{ textTransform: "capitalize" }}
                  onClick={() => handleSelectDurables("Home_cinema")}
                >
                  Home cinema / theatre / entertainment centre/HDD multimedia
                  player
                </Box>
              </Grid2>
            </Grid2>
          </Box>
        </form>
        <Button variant="contained" onClick={handleNext}>
          Submit
        </Button>
      </Box>
    </Box>
  );
};

export default CreateProfile;
